<template>
  <div class="success-page">
    <van-nav-bar
      title="资质认证"
      left-arrow
      fixed
      placeholder
      @click-left="$router.go(-1)"
    />
    <div style="margin-top: 80px">
      <i class="el-icon-success"></i>
      <p style="margin: 20px 0 10px; font-size: 16px; font-weight: 600">
        资质认证成功！
      </p>
      <p style="font-size: 13px;color:#606266">完善银行卡信息即可快速开通微信、支付宝收款账户</p>
    </div>
    <div class="btn" @click="onClick">立即完善</div>
  </div>
</template>

<script>
import "vant/lib/index.css";
import { NavBar } from "vant";
export default {
  components: {
    [NavBar.name]: NavBar,
  },
  methods: {
    onClick() {
      this.$router.replace('/simulation/douyinchuchuang/payAccount')
    },
  },
};
</script>

<style lang="less" scoped>
.success-page {
  position: relative;
  padding: 10px;
  height: 100%;
  text-align: center;
  .el-icon-success {
    font-size: 50px;
    color: #67c23a;
  }
  .btn {
    position: absolute;
    bottom: 10px;
    padding: 10px 0;
    width: 94%;
    text-align: center;
    color: #fff;
    background-color: #e21e48;
    border-radius: 3px;
    user-select: none;
    cursor: pointer;
  }
}
</style>